/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditRecordingsInner
 */
export interface BulkEditRequestBulkEditRecordingsInner {
    /**
     * Target recording id (parentRecording.id)
     * @type {string}
     * @memberof BulkEditRequestBulkEditRecordingsInner
     */
    recordingId: string;
    /**
     * OpenSearch document _id for this recording
     * @type {string}
     * @memberof BulkEditRequestBulkEditRecordingsInner
     */
    documentId?: string | null;
    /**
     * This recording's existing recording→release edge id, or null when it isn't linked yet. Per-recording, so it rides here rather than on the shared release_link object. Only meaningful alongside release_link.
     * @type {string}
     * @memberof BulkEditRequestBulkEditRecordingsInner
     */
    edgeId?: string | null;
    /**
     * The id read from this recording's validation_state, sent back unchanged, or null when the document carries none. Per-recording, so it rides here. Only meaningful alongside validation.
     * @type {string}
     * @memberof BulkEditRequestBulkEditRecordingsInner
     */
    validationId?: string | null;
}

/**
 * Check if a given object implements the BulkEditRequestBulkEditRecordingsInner interface.
 */
export function instanceOfBulkEditRequestBulkEditRecordingsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditRecordingsInnerFromJSON(json: any): BulkEditRequestBulkEditRecordingsInner {
    return BulkEditRequestBulkEditRecordingsInnerFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditRecordingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditRecordingsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingId': json['recording_id'],
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'edgeId': !exists(json, 'edge_id') ? undefined : json['edge_id'],
        'validationId': !exists(json, 'validation_id') ? undefined : json['validation_id'],
    };
}

export function BulkEditRequestBulkEditRecordingsInnerToJSON(value?: BulkEditRequestBulkEditRecordingsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_id': value.recordingId,
        'document_id': value.documentId,
        'edge_id': value.edgeId,
        'validation_id': value.validationId,
    };
}

